import React from "react";
import PlanillaPageLayout from "./PlanillaPageLayout";

const RRHHConsumision = () => (
  <PlanillaPageLayout
    title="Consumisión"
    description="Sección destinada a registrar y auditar consumos vinculados al personal."
  >
    <p className="text-muted mb-0">Próximamente se registrarán los consumos en esta sección.</p>
  </PlanillaPageLayout>
);

export default RRHHConsumision;
